<template>
	<div>
		<div class="sf-search-layout__body__container">
			<sf-search-layout>
				<el-row :gutter="20">
					<!-- 기간 단위 -->
					<el-col :span="2">
						<select-combo
							:label="getMessage_('QWCC002008')"
							paramKey="period"
							:options="searchCategory"
							:propData="searchParams.period"
							@commChange="setSearchParam"
							:showAll="false"
						></select-combo>
					</el-col>
					<!-- 검사기간 -->
					<el-col :span="3">
						<div class="sf-input-group-wrapper">
							<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001224') }}</span>
							<el-date-picker
								:value="searchParams.strDt"
								@input="value => setSearchParam({ key: 'strDt', value })"
								:type="searchParams.period === 'month' ? 'year' : 'month'"
								:value-format="searchParams.period === 'month' ? 'yyyy' : 'yyyyMM'"
								:placeholder="getMessage_('QWCC001224')"
							/>
						</div>
					</el-col>
					<!-- 품번 -->
					<el-col :span="4">
						<search-input
							:label="getMessage_('QWCC000956')"
							paramKey="partNo"
							@commInput="setSearchParam"
							:clearable="false"
							:propData="searchParams.partNo"
						>
							<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onPartPopup"></i></template>
						</search-input>
					</el-col>
					<!-- 협력사 -->
					<el-col :span="4">
						<search-input
							:label="getMessage_('QWCC000958')"
							paramKey="cofCd"
							@commInput="setSearchParam"
							:clearable="false"
							:propData="searchParams.cofCd"
						>
							<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onPqyCpnyPopup"></i></template>
						</search-input>
					</el-col>
					<!-- 검사자 -->
					<el-col :span="4">
						<search-input
							:label="getMessage_('QWCC001223')"
							paramKey="userName"
							@commInput="setSearchParam"
							:clearable="false"
							:propData="searchParams.userName"
						>
							<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onUserPopup"></i></template>
						</search-input>
					</el-col>

					<!-- 검사상태 -->
					<el-col :span="3">
						<select-combo
							:label="getMessage_('QWCC001219')"
							paramKey="pgsStCd"
							@commChange="setSearchParam"
							:options="getPgsStPcCdList_"
							:propData="searchParams.pgsStCd"
						></select-combo>
					</el-col>
					<!-- 유형 -->
					<el-col :span="3">
						<select-combo
							:label="getMessage_('QWCC000069')"
							paramKey="partClCd"
							@commChange="setSearchParam"
							:options="getPartClCdList_"
							:propData="searchParams.partClCd"
						></select-combo>
					</el-col>
				</el-row>
				<template slot="button">
					<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
						{{ getButtonMsg_(scrId, 'CR') }}
					</sf-button>
				</template>
			</sf-search-layout>
		</div>
		<part-mng-popup ref="partMngPopup" @SendData="sendData" :scrId="scrId"></part-mng-popup>
		<comp-popup ref="compPopup" @SendData="qpyCpnyData" :scrId="scrId"></comp-popup>
		<user-popup-view ref="userPopupView" @SendData="sendUserData" :scrId="scrId" />
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import SearchInput from '@qms/Components/SearchInput';
import SelectCombo from '@qms/Components/SelectCombo';
import PartMngPopup from '@qms/comm/commpopup/PartMngPopup/PartMngPopup.vue';
import CompPopup from '@qms/comm/commpopup/CompPopup/CompPopup.vue';
import UserPopupView from '@qms/comm/commpopup/UserPopup/UserPopupView.vue';
export default {
	props: { scrId: { type: String, default: '' } },
	data() {
		return {
			searchCategory: []
		};
	},
	components: { SearchInput, SelectCombo, PartMngPopup, CompPopup, UserPopupView },
	async created() {
		this.searchCategory = [
			{ label: this.getMessage_('QWCC002006'), value: 'day' },
			{ label: this.getMessage_('QWCC002007'), value: 'month' }
		];
		await this.getCommCodes_({ key: 'pgsStPcCdList', codeType: 'PGS_ST_PC' }); //검사현황
		await this.getCommCodes_({ key: 'partClCdList', codeType: 'PART_CL' }); //검사현황
		try {
			await this.searchList();
		} catch (error) {
			this.$sf_toast({ type: 'error', message: error?.message || error });
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setSearchParam({ key, value }) {
			this.setSearchParam_({ key, value });
			if (key === 'period') {
				const result = value === 'month' ? this.$moment().format('YYYY') : this.$moment().format('YYYYMM');
				this.setSearchParam_({ key: 'strDt', value: result });
			}
			if (key === 'userName') {
				this.setSearchParam_({ key: 'userId', value: '' });
			}
		},
		onPartPopup() {
			this.$refs.partMngPopup.open(this.searchParams.partNo);
		},
		//협력사조회 팝업
		onPqyCpnyPopup() {
			let params = {
				cpnyScn: '10',
				cpnyCd: this.searchParams.cofCd
			};
			this.$refs.compPopup.open(params);
		},
		sendData({ partNo }) {
			this.setSearchParam_({ key: 'partNo', value: partNo });
		},
		qpyCpnyData({ cpnyCd, cpnyNm }) {
			this.setSearchParam_({ key: 'cofCd', value: cpnyCd });
			this.setSearchParam_({ key: 'cofNm', value: cpnyNm });
		},
		async searchList() {
			this.$sf_toggleLoading(true);
			try {
				await this.getList_();
				await this.getGraph_();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message || error });
			} finally {
				this.$emit('doLoad');
				this.$sf_toggleLoading(false);
			}
		},
		onUserPopup() {
			this.$refs.userPopupView.open(this.searchParams);
		},
		sendUserData(userData) {
			this.setSearchParam_({ key: 'userId', value: userData.userId });
			this.setSearchParam_({ key: 'userName', value: userData.userName });
		},
		onUserInPutKeyDown(userGbn) {
			this.setSearchParam_({ key: 'userId', value: '' });
			this.setSearchParam_({ key: 'userName', value: '' });
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style></style>
